import React from 'react';
import { useTheme } from '@mui/material';

export const FileSuccess = (props: React.SVGProps<SVGSVGElement>) => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryColor },
    } = theme.colors.other.icon;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={42} height={42} fill="none" {...props}>
            <path
                fill={primaryColor}
                d="M4.667 37.625h16.93a13.285 13.285 0 0 0 2.444 2.323 4.46 4.46 0 0 1-.708.052H4.667C2.093 40 0 37.87 0 35.25V6.75C0 4.13 2.093 2 4.667 2h11.382a3.47 3.47 0 0 1 2.472 1.046l8.45 8.595A3.595 3.595 0 0 1 28 14.157v2.575a12.59 12.59 0 0 0-2.333.936v-1.425H17.5c-1.932 0-3.5-1.596-3.5-3.563V4.368l-9.333.007c-1.291 0-2.334 1.061-2.334 2.375v28.5c0 1.314 1.043 2.375 2.334 2.375Zm20.963-23.75a1.138 1.138 0 0 0-.306-.55l-8.451-8.601a1.142 1.142 0 0 0-.54-.312v8.276a1.18 1.18 0 0 0 1.167 1.187h8.13Zm5.87 23.75a8.095 8.095 0 0 0 5.775-2.435 8.388 8.388 0 0 0 2.392-5.877c0-2.205-.86-4.32-2.392-5.878A8.095 8.095 0 0 0 31.5 21a8.095 8.095 0 0 0-5.775 2.435 8.388 8.388 0 0 0-2.392 5.878c0 2.204.86 4.318 2.392 5.877a8.095 8.095 0 0 0 5.775 2.435Zm0-19c2.785 0 5.456 1.126 7.425 3.13A10.785 10.785 0 0 1 42 29.313c0 2.834-1.106 5.552-3.075 7.557A10.407 10.407 0 0 1 31.5 40a10.407 10.407 0 0 1-7.425-3.13A10.785 10.785 0 0 1 21 29.313c0-2.835 1.106-5.553 3.075-7.558a10.407 10.407 0 0 1 7.425-3.13Zm4.907 7.474c.452.46.452 1.217 0 1.677l-5.25 5.344c-.452.46-1.195.46-1.648 0l-2.916-2.969a1.207 1.207 0 0 1 0-1.677 1.156 1.156 0 0 1 1.648 0l2.092 2.13 4.426-4.505a1.156 1.156 0 0 1 1.648 0Z"
            />
        </svg>
    );
};

export default FileSuccess;
